import { SiteIdOverrideConfig } from "stores/wizard/config";

export const siteId70901: SiteIdOverrideConfig = {
  global: {
    heroImageSrc: "https://forever.travel-assets.com/flex/flexmanager/images/2020/08/13/V1_1400x600_Colorado-1.jpg",
  },
  car: {
    date: {
      maxDaysRange: 329,
    },
    timeFormats: {
      timeFormat12Hour: true,
    },
    AARPCheckbox: false,
    includeGT: false,
  },
  hotel: {
    packageRatesTermsUrl: "/static/default/default/taap/contracts/hpr/US.HPR.012021.pdf",
  },
  cruise: {
    heading: {
      lobSubtitleBreakPoint: "on",
      visibleLobSubtitle: true,
      locSubtitleVariant: "1-800-916-8586",
    },
  },
  lx: {
    heading: {
      visibleLobSubtitle: true,
      locSubtitleLinkUrl: "https://www.expedia.com/event-tickets/",
    },
  },
};
